<template>
    <div class="p-4" :style="{ backgroundColor: data.backgroundColor || '#F9FAFB', border: data.hasRedLine ? '2px solid red' : `${data.borderWidth || 0}px solid ${data.borderColor || '#000000'}`, borderRadius: data.hasRedLine ? '4px' : '0' }">
        <div :style="{ height: data.height || '20px', backgroundColor: data.spacerColor || '#F3F4F6' }" class="border border-gray-200 rounded"></div>
    </div>
</template>

<script>
export default {
    name: 'SpacerBlock',
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        generateHTML() {
            const height = this.data.height || '20px';
            const bgColor = this.data.backgroundColor || '#ffffff';
            const borderColor = this.data.borderColor || '#000000';
            const borderWidth = this.data.borderWidth || 0;
            
            const heightNum = parseInt(height.toString().replace('px', '').replace('em', '').replace('rem', '')) || 20;
            
            const styleAttr = this.data.hasRedLine
                ? `@if($show_clues) style="background-color: ${bgColor}; border: solid red 2px; margin-bottom: 20px;" @else style="background-color: ${bgColor}; border: ${borderWidth}px solid ${borderColor}; margin-bottom: 20px;" @endif`
                : `style="background-color: ${bgColor}; border: ${borderWidth}px solid ${borderColor}; margin-bottom: 20px;"`;
            
            return `
                <table width="100%" border="0" cellspacing="0" cellpadding="0" ${styleAttr} bgcolor="${bgColor}">
                    <tr>
                        <td height="${heightNum}" style="height: ${height}; line-height: ${height}; font-size: 1px;">&nbsp;</td>
                    </tr>
                </table>
            `;
        },
        getDefaultData() {
            return {
                height: '20px',
                backgroundColor: '#ffffff',
                spacerColor: '#F3F4F6',
                borderColor: '#000000',
                borderWidth: 0,
                hasRedLine: false
            };
        }
    }
}
</script>